export default __webpack_public_path__ + "static/POLLO_SOLO_PAPA-229cb3a96470f3a3a552c1dc2c7e962e.jpg";